import styled from "styled-components";
import SortFillIcon from "../../components/icons/SortFillIcon/SortFillIcon";
import theme from "../../style/theme";
import SortAscFillIcon from "../../components/icons/SortAscFillIcon/SortAscFillIcon";

export const AlertDeliveryGroupListSortIcon = styled(SortFillIcon)`
  fill: ${theme.palette.primitives.gray400};
  margin-right: 2px;
`;

export const AlertDeliveryGroupListAscIcon = styled(SortAscFillIcon)`
  fill: ${theme.palette.primitives.gray400};
  margin-right: 2px;
`;
